import React from "react"
import styled from "styled-components"
import Logo from "../images/logo.jpg"
import Img from "gatsby-image"
import AC from "../images/ac-2.jpg"
import Button from "./Button"

const CouponSection = styled.div`
background: rgb(0,78,146);
background: linear-gradient(145deg, rgba(0,78,146,1) 0%, rgba(0,4,40,1) 100%);
padding: 5vh 0 5vh 0;
margin: 0 0 0 0;
`
const CouponContainer = styled.div`
border: 5px dashed #CE0101;
width: 100%;
padding: 0 3rem 2rem 3rem;
position: relative;
text-align: center;
@media only screen and (min-width: 1280px) {
  text-align: left;
}
  img {
    max-width: 150px;
    border-radius: 50%;
    display: block;
    margin: 1rem auto 1rem auto;
  }
  h2 {
  text-align: center;
  margin: 1rem 0 1.5rem 0;
  font-weight: 700;
  }
  
`

const CouponSectionBackground = styled.div`
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    background-color: #fff;
    border: 1px solid #fff;
    border-radius: 10px;
    padding: 1rem 1rem;
    position: relative;

.ac {
display: block;
margin: 0 auto 0 auto;
    @media only screen and (min-width: 1024px) {
      max-width: 50%;
    }
    @media only screen and (min-width: 1280px) {
    max-width: 100%;
    }
}
`

const Test = styled.h2`
   font-family: 'Montserrat', sans-serif;
   font-weight: 700;
`

const CouponItem = styled.p`
  font-size: 1.5rem;
  color: #000;
  span {
    color: #0238AF;
    font-size: 1.5rem;
    font-weight: 700;
  }
`

const CouponDetails = styled.div`
  display: block;
  margin: 3rem auto 0 auto;
  
`
const CouponHeader = styled.h3`
font-family: Montserrat, sans-serif;
font-weight: 700;
text-align: center;
color: #CE0101;
`

const ButtonHolder = styled.div`
  text-align: center;
`

const HomeCouponSpanish = (props) => {

  return (
    <CouponSection>
      <div className="container is-desktop">
        <CouponSectionBackground>
          <div className="columns is-multiline">
            <div className="column is-4-widescreen is-12">
              <img className="ac" src={AC} alt="Picture of an blower"/>
            </div>
            <div className="column is-8-widescreen is-12">
              <CouponContainer>
                <img src={Logo} alt="Air Service Experts"/>
                <CouponHeader>Oferta Especial Nueva Instalación </CouponHeader>
                <h2>$3,995</h2>
                <CouponDetails>

                  <div className="columns is-multiline">
                    <div className="column is-6-desktop is-12">
                      <CouponItem><span>✓</span> Instalación Incluida</CouponItem>
                    </div>
                    <div className="column is-6-desktop is-12">
                      <CouponItem><span>✓</span> Modelo de Ahorro de Energía</CouponItem>
                    </div>
                    <div className="column is-6-desktop is-12">
                      <CouponItem><span>✓</span> ¡Garantía de 10 años!</CouponItem>
                    </div>
                    <div className="column is-6-desktop is-12">
                      <CouponItem><span>✓</span> Financiación por 24 meses</CouponItem>
                    </div>
                    <div className="column is-6-desktop is-12">
                      <CouponItem><span>✓</span> $0 de Enganche</CouponItem>
                    </div>

                  </div>
                  <ButtonHolder>
                    <Button url="/contact">Usar el Cupón</Button>
                  </ButtonHolder>
                </CouponDetails>

              </CouponContainer>
            </div>
          </div>
        </CouponSectionBackground>
      </div>


    </CouponSection>

  )
}

export default HomeCouponSpanish